import request from '@/utils/request';

export function getDriverByDrivingLicenseNum(number) {
    return request({
        url: '/accident/interface/drivingLicenseNum',
        method: 'get',
        params: { number }
    });
}


export function getCarLicenseByPhoto(photoUrl) {
    return request({
        url: '/accident/interface/photo/carLicense'
        , method: 'get',
        params: { photoUrl }
    });
}

export function getDrivingLicenseByPhoto(photoUrl) {
    return request({
        url: '/accident/interface/photo/drivingLicense',
        method: 'get',
        params: { photoUrl }
    });
}

export function getFaceByPhoto(data) {
    return request({
        url: '/accident/interface/photo/face',
        method: 'post',
        data
    });
}


export function getIdCardByPhoto(photoUrl) {
    return request({
        url: '/accident/interface/photo/IdCard',
        method: 'get',
        params: { photoUrl }
    });
}
